<template>
  <section class="content">
      <h3 class="subtitle">
       
      </h3>
      <h3 class="subtitle">
       <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
      <span class="sr-only">Loading...</span>
      </h3>
      <h3 class="subtitle">
       Loading...
      </h3>

      <!-- <h1 class="title">
        WTD Project
      </h1>
      <h3 class="subtitle">
        Campaign Management
      </h3> -->
  </section>
</template>
<script>

import Vue from 'vue'
import axios from '~/plugins/axios'
export default {
  layout: 'layout_login',
  data() {
    return {
      currentCampaignCode:"",
      currentCampaignName:""
    }
  },
  mounted: async function() {
    let code = this.$route.query.code;
    let state = this.$route.query.state;
    if(code && state){
      this.getBnAuth(code,state);
    }else{
      if(this.$store.state.authUser && this.$store.state.authUser.rbac ){
        let campaignCodeAllow = await this.getCamapign();
        this.$router.push('/home');
      }else{
        //console.log(process.env.baseURL)
        window.location.href = `https://accounts.trueid.net/signin?client_id=1571&redirect_uri=${process.env.baseURL}&state=home`;
      }   
    }  
  },
  methods: {
    async getBnAuth(code,state){
      try {
        let data = await this.$store.dispatch('auth', {
          code: code,
          state: state
        })
        let campaignCodeAllow = await this.getCamapign();
        this.$router.push('/home');
      } catch (e) {
        this.$router.push('/403');
      }
    },
    async getAllCampaign () {
      let url = "/api/users/get_all_campaign/";
      let { data } = await axios.get(url);
      return data.campaign;
    },
    async getCamapign () {
      let { data } = await axios.get("/api/campaign");
      let campaignList = [];
      let campaignCodeList = [];
      let campaignCodeAllow = await this.getAllCampaign();
      for (const val of data) {
        for (const campaign_code of campaignCodeAllow) {
          if(campaign_code == val.campaign_code){
            campaignList.push(val);
            campaignCodeList.push({"code":val.campaign_code,"name":val.name});
          }
        } 
      }

      if(!localStorage.getItem("now_campaign_code")){
        this.currentCampaignCode = campaignCodeList[0].code;
        localStorage.setItem("now_campaign_code",  this.currentCampaignCode);
      }

      if(!localStorage.getItem("now_campaign_name")){
        this.currentCampaignName = campaignCodeList[0].name;
        localStorage.setItem("now_campaign_name",  this.currentCampaignName);
      }

      this.campaignList = campaignList;
      
      return this.campaignList;
    },
  }
}
</script>
<style>

.content {
  justify-content: center;
  align-items: center;
  text-align: center; 
}

.title {
  font-family: 'Quicksand', 'Source Sans Pro', -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  display: block;
  font-weight: 300;
  font-size: 90px;
  margin-top: 25px;
  color: #35495e;
  letter-spacing: 1px;
}

.subtitle {
  font-weight: 300;
  font-size: 36px;
  color: #526488;
  word-spacing: 5px;
  padding-bottom: 15px;
}

.links {
  padding-top: 15px;
}
.links a {
  margin-right: 15px;
}
</style>